import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';
import { DeviceLocation } from './device-location.state';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceLocationResolverActions = createActionGroup({
  source: 'Device Location Resolver',
  events: {
    'Device Location requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceApiActions = createActionGroup({
  source: 'Apple Device API',
  events: {
    'Device Location loaded': props<{ deviceLocation: DeviceLocation }>(),
    'Device Location loaded error': props<{ error: ErrorModel }>(),
  },
});
